/**
 * AF sticky CTA — hide when footer is in view
 * Namespace: window.AfStickyCta
 *
 * Created: 2026-08-11 15:10 IST
 * Author: Cursor Agent
 * Reason: Prevent FIND YOUR AIRFRYER from covering the site footer on mobile
 *
 * Modified: 2026-08-11 17:02 IST
 * Author: Cursor Agent
 * Reason: Hide sticky while AF hero is visible (hero has its own mobile CTA)
 *
 * Modified: 2026-08-12 10:49 IST
 * Author: Cursor Agent
 * Reason: Show sticky on hero too (full-bleed mobile image; no white gap)
 *
 * Modified: 2026-09-18 16:20 IST
 * Author: Cursor Agent
 * Reason: Desktop — hide sticky while hero is in view (hero CTA first, then sticky)
 */
(function () {
  'use strict';

  var ROOT_SEL = '[data-af-sticky-cta]';
  var FOOTER_SEL = '#t4s-footer, footer.t4s-footer, #shopify-section-footer';
  var HERO_SEL = '[data-af-hero], .af-hero';
  var STARTED_SEL = '.af-started';
  var DESKTOP_MQ = '(min-width: 768px)';

  function init() {
    var sticky = document.querySelector(ROOT_SEL);
    if (!sticky || sticky.getAttribute('data-af-ready') === '1') return;

    if (!('IntersectionObserver' in window)) return;

    sticky.setAttribute('data-af-ready', '1');

    var footerHit = false;
    var heroHit = false;
    var startedHit = false;
    var mq = window.matchMedia(DESKTOP_MQ);
    var hero = document.querySelector(HERO_SEL);
    var started = document.querySelector(STARTED_SEL);
    var heroObserver = null;

    function sync() {
      var hideInSection = mq.matches && (heroHit || startedHit);
      sticky.classList.toggle('is-footer-hidden', footerHit);
      sticky.classList.toggle('is-hero-hidden', hideInSection);
      sticky.setAttribute('aria-hidden', footerHit || hideInSection ? 'true' : 'false');
    }

    function setHeroWatch(on) {
      if (!hero && !started) {
        heroHit = false;
        startedHit = false;
        sync();
        return;
      }

      if (on) {
        if (!heroObserver) {
          heroObserver = new IntersectionObserver(
            function (entries) {
              entries.forEach(function (entry) {
                if (hero && entry.target === hero) heroHit = entry.isIntersecting;
                if (started && entry.target === started) startedHit = entry.isIntersecting;
              });
              sync();
            },
            { root: null, threshold: 0 }
          );
        }
        if (hero) {
          heroObserver.observe(hero);
          heroHit = true;
        }
        if (started) {
          heroObserver.observe(started);
          startedHit = true;
        }
        sync();
        return;
      }

      if (heroObserver) {
        heroObserver.disconnect();
        heroObserver = null;
      }
      heroHit = false;
      startedHit = false;
      sync();
    }

    var footer = document.querySelector(FOOTER_SEL);
    if (footer) {
      var footerObserver = new IntersectionObserver(
        function (entries) {
          footerHit = entries.some(function (entry) {
            return entry.isIntersecting;
          });
          sync();
        },
        {
          root: null,
          threshold: 0,
          rootMargin: '0px 0px -8% 0px'
        }
      );
      footerObserver.observe(footer);
    }

    setHeroWatch(mq.matches);
    if (mq.addEventListener) {
      mq.addEventListener('change', function (e) {
        setHeroWatch(e.matches);
      });
    } else if (mq.addListener) {
      mq.addListener(function (e) {
        setHeroWatch(e.matches);
      });
    }
  }

  window.AfStickyCta = { init: init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function () {
    var sticky = document.querySelector(ROOT_SEL);
    if (sticky) sticky.removeAttribute('data-af-ready');
    init();
  });
})();
